import ApiService from '../../../services/apiService';

export default {
  isHeatMonitoringFetch(context, type, offset, limit, searchItems, filters, orderBy, options) {
    let optionsJson = JSON.stringify(options);
    if (!optionsJson) {
      optionsJson = 'null';
    }
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    let searchJson = JSON.stringify(searchItems);
    if (!searchJson) {
      searchJson = 'null';
    }
    let orderByJson = JSON.stringify(orderBy);
    if (!orderByJson) {
      orderByJson = 'null';
    }
    let params = {
      offset,
      limit,
      search_items: searchJson,
      filters: filtersJson,
      order_by: orderByJson,
      options: optionsJson,
    };
    return ApiService.instance.get(`/is-heatmonitoring/fetch/${type}`, { params }).then((response) => {
      return response.data;
    });
  },

  isHeatMonitoringCheckMeterDependency(context, meterId) {
    return ApiService.instance.get(`/is-heatmonitoring/check-meter-dependency/${meterId}`).then((response) => {
      return response.data;
    });
  },

  isHeatMonitoringFetchTagsAndZones(context, type) {
    return ApiService.instance.get('/is-heatmonitoring/tags-zones', { params: { type } }).then((response) => {
      return response.data;
    });
  },
  isHeatMonitoringFetchGeoMetaInfos(context, filters) {
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    return ApiService.instance
      .get('/is-heatmonitoring/geo-meta-infos/', {
        params: { filters: filtersJson },
      })
      .then((response) => {
        return response.data;
      });
  },
  isHeatMonitoringCheckForGeoClusters() {
    return ApiService.instance.get('/is-heatmonitoring/geo-cluster-check').then((response) => {
      return response.data;
    });
  },
  isHeatMonitoringFetchGeoClusters(context, floorDtwinId, geoBounds, searchItems, filters, options, stateKey) {
    let geoBoundsJson = JSON.stringify(geoBounds);
    if (!geoBoundsJson) {
      geoBoundsJson = 'null';
    }
    let optionsJson = JSON.stringify(options);
    if (!optionsJson) {
      optionsJson = 'null';
    }
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    let searchJson = JSON.stringify(searchItems);
    if (!searchJson) {
      searchJson = 'null';
    }
    let params = {
      floor_dtwin_id: floorDtwinId,
      geo_bounds: geoBoundsJson,
      search_items: searchJson,
      filters: filtersJson,
      options: optionsJson,
      state_key: stateKey,
    };
    return ApiService.instance.get('/is-heatmonitoring/geo-clusters/', { params, timeout: 25000 }).then((response) => {
      return response.data;
    });
  },
  isHeatMonitoringGetGeoClusterContent(context, clusterId, floorDtwinId, geoBounds, searchItems, filters, options) {
    let geoBoundsJson = JSON.stringify(geoBounds);
    if (!geoBoundsJson) {
      geoBoundsJson = 'null';
    }
    let optionsJson = JSON.stringify(options);
    if (!optionsJson) {
      optionsJson = 'null';
    }
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    let searchJson = JSON.stringify(searchItems);
    if (!searchJson) {
      searchJson = 'null';
    }
    let params = {
      floor_dtwin_id: floorDtwinId,
      geo_bounds: geoBoundsJson,
      search_items: searchJson,
      filters: filtersJson,
      options: optionsJson,
    };
    return ApiService.instance
      .get(`/is-heatmonitoring/geo-clusters/break-open/${clusterId}`, { params })
      .then((response) => {
        return response.data;
      });
  },
};
